import Request from "@services/request";

const GetProfile = async ({ id }: { id: string }) =>
    await new Request().get<IReturnValue<IUser>>({
        base: "USER_PROFILE",
        params: { id },
    });

// Main Object
const UserApis = {
    GetProfile,
};

export default UserApis;
